import React from 'react';
import PropTypes from 'prop-types';
import Nav from 'react-bootstrap/Nav';

export default class SellerGroupModelListGroupSelection extends React.Component {

  constructor(props) {
    super(props);
    // console.log('SellerGroupModelListGroupSelection-constructor:',this.props);

    let groups = this.props.groups;
    this.state = {
      currentActiveGroup: groups ? groups[0].sellerProductGroupId : null
    }
  }

  static propTypes = {
    groups: PropTypes.array.isRequired
  };

  changeGroup = e => {
    console.log(`selected group is: ${e.target.id}`);
    let nullIdIfEmptyValue = e.target.id ? e.target.id : null;
    this.props.changeGroup(nullIdIfEmptyValue);
  }

  handleSelect(eventKey) {
    console.log(`selected group is: ${eventKey}`);

    let nullIdIfEmptyValue = eventKey ? eventKey : null;
    
    this.setState({
      currentActiveGroup: eventKey
    })

    this.props.changeGroup(nullIdIfEmptyValue);
  }

  render() {
    let groups = this.props.groups;

    const groupSelections = groups.map((group, index) =>
      <Nav.Item key={group.sellerProductGroupId}>
          <Nav.Link eventKey={group.sellerProductGroupId}>
            {group.sellerProductGroupName}
          </Nav.Link>
      </Nav.Item>
    );

    return (
      <Nav variant="pills" onSelect={k => this.handleSelect(k)} activeKey={this.state.currentActiveGroup}>
        {/* <Nav.Item>
          <Nav.Link eventKey={null} >
            Models with incomplete groups
          </Nav.Link>
        </Nav.Item> */}
        {groupSelections}
      </Nav>
    )
  }
}